import { grow2529State } from '~app/pages/Pricing/experiments/grow_2529_forms/reducer';
import { grow2792State } from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/reducer';
import { PricingPackage } from '~shared/types/pricing/pricingsvc';

const NULL_PACKAGE = {} as PricingPackage;

export const packageState = {
  allPackages: [],
  userPackage: {} as PricingPackage,
  displayPackages: [],
  displayPackageSet: [],
  detailsPackageData: {},
  packagesToDisplayState: [],
  discountInfo: undefined,
  showEduDiscount: false,
  comparePlans: false,
  overageCost: undefined,
  getPackageById: (): PricingPackage => NULL_PACKAGE,
};

export const combinedStates = {
  packages: packageState,
  grow2529: grow2529State,
  grow2792: grow2792State,
};
